import { Supply } from "../types";

export const randomInt = (
  max: number = 0,
  min: number = 1,
  randomSeed = Math.random()
) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(randomSeed * (max - min) + min);
};

export const getAvailableKeysCount = (supply: Supply) =>
  supply.max -
  supply.current -
  supply.reserved +
  (supply.currentUser?.reserved ?? 0);

export const getSoldKeysCount = (supply: Supply) =>
  supply.current - supply.reserved + (supply.currentUser?.reserved ?? 0);

export const prefixZeroes = (
  value: number,
  length: number = 2,
  char: string = "0"
) => String(value).padStart(length, char);

export const largeNumberFormatting = (
  value: number,
  prefixZero: boolean = true
): string =>
  value >= 10000
    ? value < 1000000
      ? `${(value / 1000000).toLocaleString()}M`
      : `${(value / 1000).toLocaleString()}K`
    : value < 10 && value > 0 && prefixZero
    ? prefixZeroes(value, 2, "0")
    : value.toLocaleString();

export const largeMoneyFormatting = (
  value: number,
  prefixZero: boolean = true
): string => {
  if (value >= 10000) {
    if (value < 1000000) {
      const formattedValue = (value / 1000).toFixed(1);
      return `${formattedValue}${formattedValue.endsWith(".0") ? "" : "K"}`;
    } else {
      return `${(value / 1000000).toFixed(1)}M`;
    }
  } else {
    return prefixZero && value < 10 ? `0${value.toFixed(2)}` : value.toFixed(2);
  }
};
